import ExcelJS from 'exceljs';

export default class EntradasSalidasPorNombreExcelExporter {

  static async exportReporteEntradasSalidas(data, title = "Reporte Entradas/Salidas", almacenName = "") {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Entradas Salidas");

    // Agrupar los datos por la propiedad "Nombre"
    const grouped = data.reduce((acc, item) => {
      const nombre = item.Nombre || "Sin Nombre";
      if (!acc[nombre]) {
        acc[nombre] = [];
      }
      acc[nombre].push(item);
      return acc;
    }, {});

    const groupsArray = Object.keys(grouped).map(key => ({
      Nombre: key,
      Productos: grouped[key]
    }));

    // Título general (fila 1) - Se fusionan 3 columnas para las columnas: Tipo, Fecha Movimiento, Cantidad
    worksheet.mergeCells('A1:C1');
    const titleCell = worksheet.getCell('A1');
    titleCell.value = title;
    titleCell.font = { bold: true, size: 18 };
    titleCell.alignment = { horizontal: "center", vertical: "middle" };
    titleCell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: 'FFADD8E6' }, // Azul claro
    };
    // Fila vacía debajo del título
    worksheet.addRow([]);

    // Para cada grupo (producto agrupado por Nombre)
    groupsArray.forEach((group) => {
      // Fila de grupo: muestra el nombre del producto y, si se proporciona, el nombre del almacén
      const groupHeaderText = almacenName
        ? `Producto: ${group.Nombre} - Almacén: ${almacenName}`
        : `Producto: ${group.Nombre}`;
      const groupRow = worksheet.addRow([groupHeaderText]);
      groupRow.font = { bold: true, size: 14 };
      worksheet.mergeCells(`A${groupRow.number}:C${groupRow.number}`);

      // Fila de encabezados para los movimientos
      const headerRow = worksheet.addRow(["Tipo", "Fecha Movimiento", "Cantidad"]);
      headerRow.font = { bold: true, size: 12 };
      headerRow.alignment = { horizontal: "center", vertical: "middle" };
      headerRow.eachCell((cell) => {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "FFD3D3D3" } // Gris claro
        };
        cell.border = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "thin" },
          right: { style: "thin" }
        };
      });

      // Para cada producto del grupo, listar cada movimiento
      group.Productos.forEach((prod) => {
        if (prod.Movs && prod.Movs.length > 0) {
          prod.Movs.forEach((mov) => {
            const row = worksheet.addRow([
              mov.Tipo,
              mov.FechaMovimiento,
              mov.Cantidad
            ]);
            row.eachCell({ includeEmpty: true }, (cell) => {
              cell.alignment = { horizontal: "left", vertical: "middle" };
            });
          });
        } else {
          // Si el producto no tiene movimientos, mostrar una fila indicándolo.
          const row = worksheet.addRow(["Sin movimientos", "", ""]);
          row.eachCell({ includeEmpty: true }, (cell) => {
            cell.alignment = { horizontal: "left", vertical: "middle" };
          });
        }
      });

      // Fila vacía para separar cada grupo
      worksheet.addRow([]);
    });

    // Autoajuste de columnas según el contenido
    worksheet.columns.forEach((column) => {
      let maxLength = 10;
      column.eachCell({ includeEmpty: true }, (cell) => {
        const cellText = cell.value ? cell.value.toString() : "";
        maxLength = Math.max(maxLength, cellText.length);
      });
      column.width = maxLength + 2;
    });

    return workbook.xlsx.writeBuffer();
  }
}
